import {Box, Group, Modal} from '@mantine/core';
import React from 'react';
import {Subtitle} from 'src/design/atoms/Typography';

export interface ContentModalProps {
  title?: string;
  open: boolean;
  onCloseCallback: () => void;
  actions?: React.ReactNode[];
  children?: React.ReactNode;
}

export const ContentModal: React.FC<ContentModalProps> = ({
  title,
  open,
  onCloseCallback,
  children,
  actions,
}) => {
  return (
    <Modal
      opened={open}
      onClose={onCloseCallback}
      title={<Subtitle text={title} />}
      size="lg"
      padding="md">
      <Box>{children}</Box>
      {actions && (
        <Group justify="flex-end" mt="xl">
          {actions.map((action, index) => (
            <Box key={index}>{action}</Box>
          ))}
        </Group>
      )}
    </Modal>
  );
};
